import { useFloating as y, autoUpdate as E, flip as L, shift as g } from "@floating-ui/vue";
import { watch as m, unref as r, ref as p, computed as c } from "vue";
import { ELEMENT_ID as d, ELEMENT_CLASS as T, DEFAULT_DELAY as b } from "./constants.js";
const v = p(), t = p(), s = p(), { floatingStyles: o } = y(
  c(() => {
    var e;
    return r((e = s.value) == null ? void 0 : e.targetRef);
  }),
  t,
  {
    placement: c(() => {
      var e;
      return r((e = s.value) == null ? void 0 : e.placement);
    }),
    whileElementsMounted: E,
    middleware: c(() => [L(), g()])
  }
);
m(o, () => {
  t.value && (t.value.style.position = o.value.position, t.value.style.top = o.value.top, t.value.style.left = o.value.left, t.value.style.transform = o.value.transform ?? "", t.value.style.willChange = o.value.willChange ?? "");
});
m(
  s,
  (e) => {
    if (t.value)
      if (e) {
        t.value.textContent = r(e == null ? void 0 : e.content) ?? null;
        const n = r(e == null ? void 0 : e.offset);
        t.value.style.setProperty("--scalar-tooltip-offset", `${n}px`), t.value.style.setProperty("display", "block");
      } else
        t.value.textContent = null, t.value.style.removeProperty("--scalar-tooltip-offset"), t.value.style.setProperty("display", "none");
  },
  { deep: !0 }
);
function h() {
  if (t.value)
    return;
  const e = document.getElementById(d);
  e ? t.value = e : (t.value = document.createElement("div"), t.value.role = "tooltip", t.value.id = d, t.value.classList.add(T), t.value.classList.add("scalar-app"), t.value.style.setProperty("display", "none"), t.value.addEventListener("mouseleave", u), document.body.appendChild(t.value));
}
function u(e) {
  C(e) && (f(), s.value = void 0);
}
function A(e) {
  e.key === "Escape" && (e.stopPropagation(), u(e));
}
function f() {
  v.value && (clearTimeout(v.value), v.value = void 0);
}
function C(e) {
  var i;
  const n = r((i = s.value) == null ? void 0 : i.targetRef);
  return e instanceof MouseEvent && e.relatedTarget instanceof Element && n ? e.relatedTarget.id !== d && e.relatedTarget !== n : !0;
}
function _(e) {
  h();
  function n(a) {
    const l = r(e.delay) ?? b;
    f(), l > 0 ? v.value = setTimeout(() => i(), l) : i();
  }
  function i(a) {
    f(), document.addEventListener("keydown", A, { once: !0, capture: !0 }), s.value = e;
  }
  m(
    () => r(e.targetRef),
    (a, l) => {
      l && (l.removeEventListener("mouseenter", n), l.removeEventListener("mouseleave", u), l.removeEventListener("focus", i), l.removeEventListener("blur", u), l.removeAttribute("aria-describedby")), a && (a.addEventListener("mouseenter", n), a.addEventListener("mouseleave", u), a.addEventListener("focus", i), a.addEventListener("blur", u), a.setAttribute("aria-describedby", d));
    },
    { immediate: !0 }
  );
}
export {
  h as initializeTooltipElement,
  _ as useTooltip
};
